import { render, staticRenderFns } from "./DateFormatEditor.vue?vue&type=template&id=0bd84c26&scoped=true&"
import script from "./DateFormatEditor.vue?vue&type=script&lang=ts&"
export * from "./DateFormatEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DateFormatEditor.vue?vue&type=style&index=0&id=0bd84c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd84c26",
  null
  
)

export default component.exports